import React from 'react';
import { useParams } from 'react-router-dom';

export const Day: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
  const { dayNumber } = useParams<{ dayNumber: string }>();

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '1.5rem',
      padding: '2rem',
      width: '100%',
      maxWidth: '1200px',
    }}>
      <div style={{
        fontSize: 'clamp(1.7rem, 3.5vw, 2.2rem)',
        fontWeight: '600',
        color: '#ffffff',
      }}>
        {children}
      </div>
      <div style={{
        fontSize: 'clamp(2rem, 5vw, 3rem)',
        fontWeight: 'bold',
        color: '#66b3ff',
        padding: '1.25rem 2.5rem',
        background: 'rgba(77, 166, 255, 0.15)',
        borderRadius: '12px',
        border: '2px solid rgba(77, 166, 255, 0.4)',
        boxShadow: '0 4px 12px rgba(77, 166, 255, 0.3)',
      }}>
        День №{dayNumber}
      </div>
    </div>
  );
};
